import { createApi } from "@reduxjs/toolkit/query/react";
import { cacheDurationSeconds } from "common/constants";
import { baseQueryWithReauth } from "./utils/constants";
import {
	AnalysisResponse,
	AnalysisParams,
	ISaveAnalysis,
} from "./utils/interfaces";

const getGenericURLParams = (args:AnalysisParams) => {
	if(args.preset) {
		return `preset=${args.preset}&station=${args.station}`
	}
	return `startDate=${args.startDate}&endDate=${args.endDate}&station=${args.station}`
}

export const analysisApi = createApi({
	reducerPath: "analysis",
  baseQuery: baseQueryWithReauth,
	keepUnusedDataFor: cacheDurationSeconds,
	endpoints: (builder) => ({
    getAnalysis: builder.query<AnalysisResponse, AnalysisParams>({
      query: (args) => ({
        url: `get-analysis?${getGenericURLParams(args)}`,
      }),
		}),
    getActiveAnalysis: builder.query<AnalysisResponse, {userName:string}>({
      query: (args) => ({
        url: `get-active-analysis?userName=${args.userName}`,
      }),
		}),
    getInactiveAnalysis: builder.query<AnalysisResponse, {userName:string}>({
      query: (args) => ({
        url: `get-inactive-analysis?userName=${args.userName}`,
      }),
		}),
		saveAnalysis: builder.mutation<any, any>({
			query: (data) => {
				const { userName, activeStats, inactiveStats } = data;
				return {
					url: `save-analysis?userName=${userName}`,
					method: "PUT",
					body: { activeAnalysis:activeStats, inactiveAnalysis:inactiveStats }
				};
			},
		})
	}),
});

export const { useGetActiveAnalysisQuery, useGetInactiveAnalysisQuery, useGetAnalysisQuery, useSaveAnalysisMutation } = analysisApi;
